// react
import { Helmet } from 'react-helmet-async';
// mantine
import { Table } from '@mantine/core';
// components
import Header from '@/components/Layout/components/Header';
import IntegrationItem from '@/pages/Integrations/components/IntegrationItem';
import { EmptyState, LoadingState } from '@/components/Table';
// utils
import { useIntegrationsQuery } from '@/services/integration/integration.queries.ts';
import { PageContainer } from '@/components/PageContainer/PageContainer.tsx';

const Integrations = () => {
    const {
        data: integrations,
        isLoading,
        isFetching
    } = useIntegrationsQuery();
    return (
        <div className="w-full h-full">
            <Helmet>
                <title>NEWO - Integrations</title>
            </Helmet>
            <PageContainer className="px-0" pb="xs">
                <Header breadcrumbs={[{ label: 'Integrations' }]} />
                <Table.ScrollContainer className="px-4 pt-4" minWidth={800}>
                    <Table>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Name</Table.Th>
                                <Table.Th>Connectors</Table.Th>
                                <Table.Th>Status</Table.Th>
                                <Table.Th />
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {isLoading ? <LoadingState /> : undefined}
                            {!isFetching && !integrations?.length && (
                                <EmptyState />
                            )}
                            {integrations?.map((integration) => (
                                <IntegrationItem
                                    integration={integration}
                                    key={integration.id}
                                />
                            ))}
                        </Table.Tbody>
                    </Table>
                </Table.ScrollContainer>
            </PageContainer>
        </div>
    );
};

export default Integrations;
